import type { SideId } from '@/domain/anatomy/side';
import { findPlaneMeasurement, type MeasurementGroup } from '@/domain/anatomy/measurements';
import { vector3 } from '@/domain/geometry/vector3';
import {
    type AcetabularAngles,
    radiographicAnteversion,
    radiographicInclination,
} from '@/domain/anatomy/pelvis/acetabularAngles';
import type { LpsVectors } from '@/domain/anatomy/LPS';

/** Calculate the acetabular-angles of the native acetabular plane in radiographic convention */
export function nativeAcetabularAngles(
    side: SideId,
    measurements: MeasurementGroup[],
    lpsVectors: LpsVectors
): AcetabularAngles<'radiographic'> {
    const acetabularPlane = findPlaneMeasurement(
        measurements,
        'pelvis',
        `hip_pelvis_acetabulum_plane_${side}`,
    );
    // Negate the acetabular normal, as it points into the acetabulum.
    const acetabularNormal = vector3(acetabularPlane.value).negate();
    return {
        system: 'radiographic',
        anteversion: radiographicAnteversion(acetabularNormal, lpsVectors),
        inclination: radiographicInclination(acetabularNormal, lpsVectors),
    };
}
